import useNewCareerPositionContext from 'contexts/career-position.context';
import moment from 'moment';
import React from 'react';

const PreviewJobAppSettings = () => {
  const { createJobPositionForm } = useNewCareerPositionContext();

  const details = [
    {
      value: createJobPositionForm.applicationDeadline
        ? moment(new Date(createJobPositionForm.applicationDeadline)).format('ddd MMM DD, yyyy')
        : 'No date selected',
      label: 'Application deadline'
    },
    { value: createJobPositionForm.noOfOpenings ?? 0, label: 'No. of openings' }
  ];
  return (
    <div className='space-y-6'>
      {details.map((detail) => (
        <div
          key={detail.label}
          className='border border-gray-1 rounded-md p-3.5 flex items-center mb-4'>
          <h2 className='text-sm   text-gray-5 w-40'>{detail.label}</h2>
          <p className='text-base text-gray-6 font-medium'>{detail.value}</p>
        </div>
      ))}
    </div>
  );
};

export default PreviewJobAppSettings;
